import { FC } from "react";

interface AdminPageProps {}

const AdminPage: FC<AdminPageProps> = () => {
  return <div>OpenStory Admin Panel. Use left side navigation to manage content</div>;
};

export default AdminPage;
